import { Model } from 'modules/core/lib/mobx-rest'

interface IHiddenTeam {
  id: number
  ats_company_id: number
  team_id: number
}

class HiddenTeam extends Model<IHiddenTeam> {
  static urlRoot() {
    return '/ats/hidden_teams'
  }
}

export default HiddenTeam
